const playmakerChosenSizes = new Map();

const playmakerIsSize = (input) => {
  const name = (input.dataset.optionName || '').trim().toLowerCase();
  return name === 'size' || name === 'מידה';
};

// The theme selects the first variant in its markup. Keep the price visible,
// but let the shopper make the size selection instead of implying they did.
document.querySelectorAll('variant-picker').forEach((picker) => {
  picker.querySelectorAll('input[type="radio"][data-option-name]').forEach((input) => {
    if (playmakerIsSize(input)) {
      input.checked = false;
      input.removeAttribute('checked');
    }
  });
});

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const picker = target.closest('variant-picker');
  if (!picker) return;
  const input = target.matches('input[type="radio"]')
    ? target
    : target.closest('label')?.querySelector('input[type="radio"]');
  if (!(input instanceof HTMLInputElement) || !playmakerIsSize(input)) return;
  playmakerChosenSizes.set(picker.dataset.productId, input.value);
  const section = picker.closest('.shopify-section');
  section?.querySelector('.pm-size-error')?.remove();
}, true);

const playmakerCheckSize = (event, form) => {
  if (!(form instanceof HTMLFormElement) || form.dataset.type !== 'add-to-cart-form') return;
  const component = form.closest('product-form-component');
  if (!component) return;
  const section = component.closest('.shopify-section');
  const productId = component.dataset.productId;
  const picker = section?.querySelector('variant-picker[data-product-id="' + productId + '"]');
  if (!picker) return;
  const sizes = [...picker.querySelectorAll('input[type="radio"][data-option-name]')].filter(playmakerIsSize);
  if (!sizes.length) return;
  const selected = sizes.find((input) => input.checked);
  if (selected && playmakerChosenSizes.get(productId) === selected.value) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  let error = section.querySelector('.pm-size-error');
  if (!error) {
    error = document.createElement('p');
    error.className = 'pm-size-error';
    error.setAttribute('role', 'alert');
    form.querySelector('.product-form-buttons')?.before(error);
  }
  error.textContent = 'בחרו מידה לפני ההוספה לסל.';
  selected?.focus();
  picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
};

// Easify handles the button click itself, before a native submit can be stopped.
window.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const button = target.closest('button[type="submit"]');
  if (!button) return;
  playmakerCheckSize(event, button.closest('form'));
}, true);

window.addEventListener('submit', (event) => {
  playmakerCheckSize(event, event.target);
}, true);
